import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  packageDocId: string;
  data: any;
}

const mutateUpdateOCPClosingDocument = async ({
  ocpId,
  packageDocId,
  data,
}: mutateProps) => {
  return await axiosAuth.put(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/documents/${packageDocId}/file`,
    data,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

const useUpdateOCPClosingDocumentMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateUpdateOCPClosingDocument,
    ...queryParams,
  });

export default useUpdateOCPClosingDocumentMutation;
